<template>
  <div class="top">
    <ul class="top-slides-bg-circles">
    </ul>
    <ul class="top-slides-bg-circles2">
    </ul>
    <v-container fluid>
      <div class="top-slides-bg" ref="getSlidesHeight">
        <div class="top-link">
          <v-row class="music-story">
            <v-col cols="12"><p class="topic">Order</p></v-col>
            <v-col cols="12" class="d-flex flex-column justify-center">
              <p class="order-top">ご依頼につきまして</p>
              <p class="order-text mt-4">以下が可能です 納期費用はご相談ください</p>
              <p class="order-text">3日以内を目安にご連絡いたします</p>
              <p class="order-menu mt-2">作曲系: ゲームBGM全般, インスト曲, ピアノ曲</p>
              <p class="order-menu mt-1">音系: ピアノ編曲, 聴音・採譜, その他和声関係作業</p>
              <p class="order-note mt-2">※ゲームBGMの場合は基本的に実績として掲載させて頂きます</p>
              <p class="order-note">掲載不可希望はご相談ください</p>
              <p class="order-note mt-1">※ピアノ曲の場合、楽譜の有無が選択いただけます</p>
              <p class="order-note">楽譜ありの場合、追加の費用と納期が発生します</p>
              <p class="order-note mt-1">※<a>自プロジェクト・既に進行中のプロジェクトの合間でのご対応</a>となります</p>
              <p class="order-note">そのため状況によりお断りさせて頂く可能性があることをご了承ください</p>
              <p class="order-note">ご相談頂いた時点で対応可否のご連絡をさせて頂きます</p>
              <p class="order-text mt-4">ご相談内容によっては優先対応が可能です</p>
              <p class="order-text mb-4">詳しくはご相談ください</p>
              <v-card flat shaped>
                <v-btn
                    flat
                    color="#f8c6c6"
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdXY0XMOeJz-aDWxpiDzTh1qhc5Abs8PrmayWnvpLwlRkE29Q/viewform?usp=sf_link"
                    target="_blank"
                ><p style="color: #555">CONTACT</p></v-btn>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  methods: {
    onReady() {
      this.$refs.youtube.playVideo()
    },
  },
};
</script>

<style scoped>
.top-slides-bg-circles {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.top-slides-bg-circles li {
  position: absolute;
  overflow: hidden;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: #f8c6c6;
  opacity: 0;
  animation: animate 25s linear infinite;
}
.top-slides-bg-circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}
.top-slides-bg-circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}
.top-slides-bg-circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}
.top-slides-bg-circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}
.top-slides-bg-circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}
.top-slides-bg-circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}
.top-slides-bg-circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}
.top-slides-bg-circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}
.top-slides-bg-circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}
.top-slides-bg-circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}
.top-slides-bg-circles2 {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.top-slides-bg-circles2 li {
  position: absolute;
  overflow: hidden;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: #adb9de;
  opacity: 0;
  animation: animate 25s linear infinite;
}
.top-slides-bg-circles2 li:nth-child(1) {
  left: 80%;
  width: 80px;
  height: 80px;
  animation-delay: 6s;
}
.top-slides-bg-circles2 li:nth-child(2) {
  left: 55%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
  animation-duration: 14s;
}
.top-slides-bg-circles2 li:nth-child(3) {
  left: 30%;
  width: 20px;
  height: 20px;
  animation-delay: 16s;
}
.top-slides-bg-circles2 li:nth-child(4) {
  left: 15%;
  width: 60px;
  height: 60px;
  animation-delay: 4s;
  animation-duration: 16s;
}
.top-slides-bg-circles2 li:nth-child(5) {
  left: 40%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}
@keyframes animate {
  0% {
    transform: translateY(1000px) rotate(0deg);
    opacity: 0.4;
    border-radius: 20%;
  }
  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0.2;
    border-radius: 40%;
  }
}
</style>
